import { ArrowDown, ArrowUp, ArrowUpDown } from 'lucide-react';
import { exhaustiveCheck } from '../../../../../../utils/exhaustive-check';
import { SortingVariant } from '../table-sorting-content';

export const getSortingVariantContent = (variant?: SortingVariant) => {
  if (!variant) {
    return {
      label: 'Sort',
      icon: ArrowUpDown,
    };
  }

  switch (variant) {
    case 'CONFIDENCE_SCORE_LOW_TO_HIGH':
      return {
        label: 'Confidence Score',
        text: 'Low to High',
        icon: ArrowDown,
      };
    case 'CONFIDENCE_SCORE_HIGH_TO_LOW':
      return {
        label: 'Confidence Score',
        text: 'High to Low',
        icon: ArrowUp,
      };
    case 'DATE_OLD_TO_NEW':
      return {
        label: 'Date',
        text: 'Old to New',
        icon: ArrowDown,
      };
    case 'DATE_NEW_TO_OLD':
      return {
        label: 'Date',
        text: 'New to Old',
        icon: ArrowUp,
      };
    default:
      return exhaustiveCheck(variant);
  }
};
